module.exports = __webpack_public_path__ + "static/media/ic_informacion_seleccionado.37d2791d.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_informacion_seleccionado.webp
// module id = 179
// module chunks = 1